/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator>): AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator(), model);
        AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator>): AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.newInstance(<AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityExploitabilityUserInteractionV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Exploitability metric(s) user interaction v3.1 to include
     */
    user_interaction_v31: Array<models.CvssV31ExploitabilityUserInteraction>;

}
